// 接口域名地址
let baseURL = 'https://adr.ccpit.org/interface';
let PCURL = 'https://m.adr.ccpit.org';
let appName = 'mediate';
export default {
  baseURL,
  appName,
  PCURL,
};
